import { useState } from 'react';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { UserService } from '../Service';
import { useAppContext } from '../../../../contexts/AppContext';
import moment from 'moment';
import { SettingsRow, SettingsSection } from '../../estabelecimento/Form/SettingsGroup';
const service = new UserService();

export default function ConfiguracoesContaEmail() {
    const { errorSnackbar, successSnackbar } = useAppContext();

    const [loading, setLoading] = useState(false);
    const [expiresIn, setExpiresIn] = useState();

    const { user, changeUser } = useAuthContext();
    const [code, setCode] = useState('');
    const [email, setEmail] = useState(user?.email || '');

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!!email && email !== user?.email) {
            setLoading(true);
            try {
                const response = await service.requestChangeEmail(email);

                if (!response?.data?.expiresIn) {
                    throw new Error('Erro ao gerar token');
                }

                setExpiresIn(response?.data?.expiresIn);
                successSnackbar('Código de confirmação enviado com sucesso!');
            } catch (e) {
                console.log(e);
                errorSnackbar('Ocorreu um erro ao alterar o e-mail.');
            } finally {
                setLoading(false);
            }
        }
    };

    const handleSubmitCode = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!!code) {
            setLoading(true);
            try {
                await service.changeEmail(code);

                setCode('');
                setExpiresIn(undefined);
                successSnackbar('E-mail alterado com sucesso!');
                changeUser({ email });

                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            } catch (e) {
                console.log(e);
                errorSnackbar('Código inválido.');
            } finally {
                setLoading(false);
            }
        }
    };

    const isVerifying = !!expiresIn;

    if (isVerifying) {
        return (
            <form onSubmit={handleSubmitCode}>
                <div className="grid gap-6 xl:grid-cols-2 xl:items-start">
                    <SettingsSection
                        title="Confirmar novo e-mail"
                        footer={
                            <>
                                Enviamos um código de verificação para <span className="font-medium">{email}</span>. O
                                código expira em: {moment(expiresIn).format('DD/MM/YYYY [às] HH:mm')}.
                            </>
                        }
                    >
                        <SettingsRow label="Código" htmlFor="token">
                            <input
                                type="text"
                                id="token"
                                required
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                className="input estab-field"
                                placeholder="Código de confirmação"
                                autoComplete="one-time-code"
                                disabled={loading}
                            />
                        </SettingsRow>
                    </SettingsSection>
                </div>

                <div className="estab-savebar mt-6 gap-2">
                    <button
                        onClick={() => {
                            setCode('');
                            setExpiresIn(undefined);
                        }}
                        className="btn btn-ghost flex-1 sm:flex-none sm:min-w-[8rem]"
                        type="button"
                        disabled={loading}
                    >
                        Cancelar
                    </button>
                    <button
                        className="btn btn-primary flex-1 sm:flex-none sm:min-w-[11rem]"
                        type="submit"
                        disabled={loading}
                    >
                        {loading && <span className="loading loading-spinner loading-sm"></span>}
                        Confirmar
                    </button>
                </div>
            </form>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid gap-6 xl:grid-cols-2 xl:items-start">
                <SettingsSection
                    title="E-mail de acesso"
                    footer="Usado no login. Enviaremos um código de verificação para confirmar a mudança."
                >
                    <SettingsRow label="E-mail" htmlFor="email">
                        <input
                            type="email"
                            id="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input estab-field"
                            autoComplete="email"
                            disabled={loading}
                        />
                    </SettingsRow>
                </SettingsSection>
            </div>

            <div className="estab-savebar mt-6">
                <button
                    className="btn btn-primary w-full sm:w-auto sm:min-w-[11rem]"
                    type="submit"
                    disabled={loading || !email || email === user?.email}
                >
                    {loading && <span className="loading loading-spinner loading-sm"></span>}
                    Continuar
                </button>
            </div>
        </form>
    );
}
